import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import style from './index.module.scss';
SwiperCore.use([Pagination]);

const { EFPic } = createEFPic('/media/collection/');

export default function SolarTopNav({ navList = [], query = '', powerActiveKey = '' }: any) {
    const { Link, useState, useLang } = useGlobal();
    const { t } = useLang('shared');
    const [renderkey, setRenderkey] = useState(typeof window !== 'undefined' && window.innerWidth);
    const insideNanList = navList.filter((item: any) => item.detLink !== null);

    const getDataLayer = (conts: any) => {
        const queryMap: any = {
            power: 'Portable Power Stations',
            solutions: 'Solutions',
            'solar-generators': 'Solar Panels',
            solar: 'Solar Panels',
            smart: 'Smart Home',
        };
        const firstName = queryMap[query] || '';
        let secondName = '';
        if (query === 'power' || query === 'portable-power-stations') {
            secondName = powerActiveKey === 'delta' ? 'DELTA Series' : 'RIVER Series';
        }
        if (query === 'solar-generators') {
            secondName = powerActiveKey === 'generators' ? 'Solar Generators' : 'Solar Panels';
        }
        let thirdName = conts.name;
        // 配件页,对比页
        if (conts.isComparison || conts.isAccessories || conts.isIconName) {
            thirdName = conts.iconName;
        }
        return {
            event: 'uaEvent',
            event_name: 'top_third_navigation',
            navigation_name: `${firstName}_${secondName}_${thirdName}`,
        };
    };

    return (
        <div className={style.solarTopnav}>
            <div className="nav-wrapper">
                <Swiper
                    pagination={{ clickable: true }}
                    initialSlide={0}
                    width={renderkey}
                    preloadImages={false}
                    slidesPerView={3}
                    slidesPerGroup={3}
                    spaceBetween={0}
                    loopAdditonalSlides={3}
                    loopFillGroupWithBlank={true}
                    lazy={true}
                >
                    {insideNanList.map((item: any, index: number) => {
                        return (
                            <SwiperSlide key={`${index}i`}>
                                <div className="navitem">
                                    <Link href={item.detLink || ''} target={item.target || '_self'} dataLayer={getDataLayer(item)}>
                                        <div className="img-wrapper">
                                            {item.imgSrc ? (
                                                Array.isArray(item?.imgSrc) ? (
                                                    <EFPic
                                                        name={item?.imgSrc}
                                                        className="containImgs"
                                                        alt="DELTA Pro Solar Generators"
                                                        aria-label="DELTA Pro Solar Generators"
                                                    />
                                                ) : (
                                                    <Image
                                                        src={item.imgSrc}
                                                        layout="fill"
                                                        className="containImgs"
                                                        noUseSrcset={true}
                                                        alt="DELTA Pro Solar Generators"
                                                        aria-label="DELTA Pro Solar Generators"
                                                    />
                                                )
                                            ) : (
                                                item.icons
                                            )}
                                        </div>
                                        <div className="item-name">
                                            {item.name}
                                            {item.tag && item.tag !== 'New' && <p className="tag">{item.tag}</p>}
                                            {item.tag && item.tag === 'New' && (
                                                <p className="tag" style={{ color: '#fa4500', display: 'block', marginLeft: '0' }}>
                                                    {t('product.nav_new')}
                                                </p>
                                            )}
                                        </div>
                                    </Link>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>
    );
}
